module.exports = __webpack_public_path__ + "static/media/chirag.44672553.jpg";